var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ChangeEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class ChecklistAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onChange = new ChangeEventListener();
    }
    /**
     * Marks all items of the checklist as checked.
     */
    checkAll() {
        const { value: oldValue } = this.state;
        const value = this.getData().map(({ key, label }) => ({ key, label }));
        // @ts-ignore: Yes, most of the types in this api are wrong, we need to review them all
        this.onChange.fire({ oldValue, value });
    }
    /**
     * Clear all the checks in the checklist.
     */
    clear() {
        const { value: oldValue } = this.state;
        // @ts-ignore: Yes, most of the types in this api are wrong, we need to review them all
        this.onChange.fire({ oldValue, value: [] });
    }
    /**
     * Gets the items of the checklist.
     *
     * @returns the items of the checklist.
     */
    getData() {
        return this.state.data;
    }
    /**
    * Sets the items of the checklist.
    *
    * @param data - The items of the checklist.
    */
    setData(data) {
        this.setState({ data });
    }
    /**
     * Gets the density of the checklist.
     *
     * @returns the density of the checklist.
     */
    getDensity() {
        return this.state.density;
    }
    /**
    * Sets the density of the checklist.
    *
    * @param density - The density of the checklist.
    */
    setDensity(density) {
        this.setState({ density });
    }
    /**
    * Sets the disabled items in the checklist.
    *
    * @param keys - The keys of the disabled items in the checklist.
    */
    setDisabledKeys(keys) {
        this.setState({ disabledKeys: keys });
    }
    /**
     * Gets the keys of the disabled items in the checklist.
     *
     * @returns an array with the keys of the disabled items in the checklist.
     */
    getDisabledKeys() {
        return this.state.disabledKeys;
    }
    /**
     * Checks if the checklist is enabled.
     *
     * @returns a boolean indicating if the checklist is enabled.
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets if the checklist should be enabled.
     *
     * @param enabled - If the checklist should be enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
     * Checks if the checklist is read only.
     *
     * @returns a boolean indicating if the checklist is read only.
     */
    isReadOnly() {
        return Boolean(this.state.readOnly);
    }
    /**
     * Sets if the checklist should be read only.
     *
     * @param readOnly - If the checklist should be read only.
     */
    setReadOnly(readOnly) {
        this.setState({ readOnly });
    }
    /**
     * Checks if the check all option is visible.
     *
     * @returns a boolean indicating if the check all option is visible.
     */
    isShowCheckAll() {
        return this.state.showCheckAll;
    }
    /**
     * Sets if the check all option should be visible.
     *
     * @param showCheckAll - If the check all option should be visible.
     */
    setShowCheckAll(showCheckAll) {
        this.setState({ showCheckAll });
    }
    /**
     * Gets the value of the checklist.
     *
     * @returns the value of the checklist.
     */
    getValue() {
        return this.state.value;
    }
    /**
    * Sets the value of the checklist.
    *
    * @param value - The value of the checklist.
    */
    setValue(value) {
        const { value: oldValue } = this.state;
        this.setState({ value });
        this.onChange.fire({ oldValue, value });
    }
    /**
     * Checks if the field value is being struckthrough.
     *
     * @returns a boolean indicating if the field value is being struckthrough.
     */
    isStrikethrough() {
        return Boolean(this.state.strikethrough);
    }
    /**
     * Sets if the field value should be struckthrough.
     *
     * @param strikethrough - If the field value should be struckthrough.
     */
    setStrikethrough(strikethrough) {
        this.setState({ strikethrough });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], ChecklistAPI.prototype, "onChange", void 0);
export { ChecklistAPI, };
//# sourceMappingURL=checklist-api.js.map